import { IS_APP, IS_TESTING } from "@/__main__/constants.mjs";
import eventBus from "@/app/app-event-bus.mjs";
import { EVENT_TRACK_AD_VIDEO_VIEW } from "@/feature-ads/constants/events.mjs";
import { getPageTargetingMap } from "@/feature-ads/display-server-google.mjs";
import adsRefs from "@/feature-ads/refs.mjs";
import globals from "@/util/global-whitelist.mjs";

const DIV_ID = "pb-slot-outstream-standalone";
const ELEMENT_ID = "outstream-player-div";

// @ts-ignore
// eslint-disable-next-line no-restricted-properties
const global = globalThis;
global.tude = global.tude || { cmd: [] };

async function handleImpressionEvent() {
  let ram = 0;
  if (IS_APP) {
    const heapStats = await globals.__BLITZ__.process.getHeapStatistics();
    ram = heapStats.usedHeapSize * 1024;
    // @ts-ignore
  } else if (globals.performance.memory) {
    // @ts-ignore
    ram = globals.performance.memory.usedJSHeapSize;
  }

  eventBus.emit(EVENT_TRACK_AD_VIDEO_VIEW, {
    provider: "aditude",
    ram,
  });
}

export const VIDEO_ADITUDE = {
  aspectRatio: "16 / 9",
  init: () => {},
  initializePlacement(/*element: HTMLElement*/) {
    const outstreamPlayer = globals.document.createElement("div");
    outstreamPlayer.id = ELEMENT_ID;
    return outstreamPlayer;
  },
  onPlacementAppend(_parent: HTMLElement, _placement: HTMLElement) {
    global.tude.cmd.push(function () {
      global.tude.requestOutstreamAd({
        divId: ELEMENT_ID, // player will be injected into this div
        baseDivId: DIV_ID,
        playerOptions: {
          showCloseButton: true,
          dock: true,
          dockedPosition: "bottom-left",
          dockedOffset: {
            bottom: 5,
            left: 5,
          },
        },
      });
    });
    adsRefs
      .googleCmd(() => {})
      .then(() => {
        const pageTargeting = getPageTargetingMap();
        if (pageTargeting) {
          global.Raven = global.Raven || { cmd: [] };
          global.Raven.cmd.push(({ config }) => {
            config.setCustom({
              param2: pageTargeting.game,
              param4: pageTargeting.route,
            });
          });
        }
      });

    globals.document
      .getElementById(ELEMENT_ID)
      ?.addEventListener("IMPRESSION", handleImpressionEvent);
  },
  onDestroy(_activeRef) {
    globals.document
      .getElementById(ELEMENT_ID)
      ?.removeEventListener("IMPRESSION", handleImpressionEvent);
  }, // noop
  vendorCloseButton: true,
  vendorIntersectionFloat: !IS_TESTING,
  vendorNavFloat: false,
  onNavFloat: () => {},
};
